export const defaultTheme = () => [
    {
        name: "Theme 1",
        lightGradient: "to top right, rgba(255,255,255,.7), rgba(58,58,58,.8)",
        darkGradient: "to top right, rgba(25,25,25,1), rgba(255,255,255,.8)",
        light: {
            'appointment-group-header-nth-even': "#f3f3f3",
            'appointment-group-header-background': "#e1e1e1",
            'appointment-group-header-nth': "#efefef",
            'appointment-group-header-text': "#000000",
            'item-discounted': "#EC6906", //Orange
            //background
            //being worked on:
            //finished:
            //unplanned:
            accent: "#ff8e00",
            background: "#FFF",
            backgroundworker: "#3b3f40",
            code: "#EEE",
            contentboxBackground: "#F5F5F5",
            close: "#222",
            disabled: "#CCC",
            error: "#e8756d",
            firstlineCommentBackground: "#fffdd0",
            footer: "#1e1e1e",
            header: "#F9F9F9",
            info: "#2e8ac0",
            invoiceCommentBackground: "#e0f2d8",
            key: "#FB8C00",
            previewcolor: '#f9f9f9',
            primary: "#427aaf", //Blue
            primarytext: "#427aaf", //Blue
            quaternary: "#8bb84b", //Green
            quinary: "#f1b202", //yellow
            senary: "#4caf9f", //Mint
            secondary: "#EC6906", //Orange
            success: "#8bb84b",
            tertiary: "#ff8e00", //Purple
            text: "#000",
            ThemeText: "#262626",
            logobackground: "#ededed",
            navigationtext: "#6b6b6b",
            navigationdrawer: "#F2F2F2",
            'navigationdrawer-active': "#FBFBFB",
            'navigationdrawer-selected': "#FFF",
            'list-odd-marked': "#f5f9ff",
            'list-new': "#f1fcf4",
            'list-change': "#fcf9f1",
            'list-error': "#fcf1f1",
            'list-deleted': "#eeeeee",
            'theme-dark': "#000000",
            'theme-light': "#000000",
            'dark-text': "#000",
            'header-background': "#bac6d0"
        },
        dark: {
            'appointment-group-header-nth-even': "#312b2b",
            'appointment-group-header-background': "#2a2424",
            'appointment-group-header-nth': "#524747",
            'appointment-group-header-text': "#f2f2f2",
            'dark-text': "#ceebf9",
            'item-discounted': "#EC6906", //Orange
            'list-change': "#454340",
            'list-deleted': "#423b3b",
            'list-error': "#423b3b",
            'list-new': "#3d423e",
            'list-odd-marked': "#393b3d",
            'logobackground': "#888",
            'navigationdrawer-active': "#000",
            'navigationdrawer-selected': "#444",
            'navigationdrawer': "#333",
            'navigationtext': "#f2f2f2",
            'theme-dark': "#f4f4f4",
            'theme-light': "rgba(244,244,244, 0.03)",
            'theme-text': "#fff",
            accent: "#ff8e00",
            background: "#303030",
            code: "#101010",
            contentboxBackground: "#373737",
            disabled: "#CCC",
            error: "#FF5252",
            footer: "#1e1e1e",
            header: "#404040",
            info: "#4080A0",
            key: "#a1e754",
            primary: "#427aaf", //Blue
            primarytext: "#d3e0ed", //Blue
            quaternary: "#44AF42", //Green
            quinary: "#f1b202", //yellow
            senary: "#339f80", //Mint
            secondary: "#EC6906", //Orange
            success: "#86af3f",
            tertiary: "#AD42AF", //Purple
            text: "#FFF",
            warning: "#FB8C00",
        },
    },
    {
        name: "Theme 2",
        lightGradient: "to top right, rgba(55,55,55,0.0), rgba(22,22,22,.8)",
        darkGradient: "to top right, rgba(50,50,50,1), rgba(155,63,82,.8)",
        light: {
            primary: "#df9440",
            accent: "#a1e754",
            secondary: "#a5d64c",
            header: "#F0F0F0",
            success: "#4CAF50",
            info: "#2e8ac0",
            warning: "#FB8C00",
            error: "#ff5e3c",
            key: "#FB8C00",
            code: "#EEE",
        },
        dark: {
            primary: "#E65100",
            accent: "#FF4081",
            secondary: "#2e8ac0",
            success: "#4CAF50",
            header: "#404040",
            info: "#6156d8",
            warning: "#1565C0",
            error: "#FF7043",
            key: "#a1e754",
            code: "#101010",
        },
    },
];